module.exports = __webpack_public_path__ + "static/media/s3.0ef5df0b.svg";